define('TescoMobile_Checkout/js/checkout-fingerprint',['./model/create-device-fingerprint-url', 'TescoMobile_Iovation/js/model/device-fingerprint-config', 'TescoMobile_Iovation/js/iovation'], function (createDeviceFingerprintUrl, fingerprintConfig, iovation) {
  'use strict';

  return function (config) {
    fingerprintConfig.isConfigLoaded = true;
    fingerprintConfig.isFingerprintSaved = config.isFingerprintSaved;
    fingerprintConfig.isRetryVersionEnabled = config.isRetryVersionEnabled;
    fingerprintConfig.maxRetries = config.maxRetries;
    iovation({
      'callback': createDeviceFingerprintUrl()
    });
  };
});

